import React from "react";
import { useT } from "@/lib/LanguageContext";
import { cn } from "../../../lib/utils";
import { MERGE_FIELDS } from "../contract";
import { FOCUS_RING } from "./classes";

/** "Merge fields: {client_name} {practice_name} …" — each chip inserts its token. */
export default function MergeFieldPicker({ onInsert, fields = MERGE_FIELDS, testIdPrefix }) {
  const t = useT("crm");
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm text-eh-muted">
      <span>{t("merge.label")}</span>
      {fields.map((f) => (
        <button key={f} type="button" onClick={() => onInsert(f)} data-testid={testIdPrefix ? `${testIdPrefix}-${f.slice(1, -1)}` : undefined}
          className={cn("rounded-full bg-white px-2.5 py-0.5 text-xs text-eh-ink hover:bg-eh-cream-deep font-mono", FOCUS_RING)}>
          {f}
        </button>
      ))}
    </div>
  );
}

/** Inserts `token` into a textarea's value at its caret; returns the new value and caret. */
export const insertAtCaret = (el, value, token) => {
  const start = el && typeof el.selectionStart === "number" ? el.selectionStart : value.length;
  const end = el && typeof el.selectionEnd === "number" ? el.selectionEnd : value.length;
  return { value: value.slice(0, start) + token + value.slice(end), caret: start + token.length };
};
